// GeneralMetrics.js
import React, { useMemo } from 'react';
import { Table, Button } from 'antd';
import TickerChip from "../../Components/TickerChip";
import { DoubleLine } from "../../Components/Labels";
import { isUUID } from "../../utils/strings";
import {ComparisonRowTitleComponent} from "./common";

const formatters = {
  'metrics.pe_ttm': (v) => v?.toFixed(2) ?? 'N/A',
  'metrics.price_book': (v) => v?.toFixed(2) ?? 'N/A',
  'metrics.price_sales': (v) => v?.toFixed(2) ?? 'N/A',
  'metrics.dy': (v) => v != null ? `${(v * 100).toFixed(2)}%` : 'N/A',
};

const GeneralMetrics = ({ tickerData, portfolioMetadata, tickers, onRemoveSymbol }) => {
  const mergedTickerData = useMemo(() => {
    return Object.entries(tickerData).map(([symbol, data]) => {
      return {
        key: symbol,
        symbol,
        ...data,
      }
    });
  }, [tickerData, portfolioMetadata, tickers]);

  const columns = [
    {
      title: 'Symbol/Portfolio',
      dataIndex: 'symbol',
      key: 'symbol',
      render: (symbol, record) => <ComparisonRowTitleComponent symbol={symbol} record={record}/>,
    },
    {
      title: 'Sector',
      dataIndex: ['tags', 'sector'],
      key: 'sector',
    },
    {
      title: 'Industry',
      dataIndex: ['tags', 'industry'],
      key: 'industry',
    },
    {
      title: 'P/E',
      dataIndex: ['metrics', 'pe_ttm'],
      key: 'pe',
      render: (value) => formatters['metrics.pe_ttm'](value),
    },
    {
      title: 'P/B',
      dataIndex: ['metrics', 'price_book'],
      key: 'pb',
      render: (value) => formatters['metrics.price_book'](value),
    },
    {
      title: 'P/S',
      dataIndex: ['metrics', 'price_sales'],
      key: 'ps',
      render: (value) => formatters['metrics.price_sales'](value),
    },
    {
      title: 'Dividend Yield',
      dataIndex: ['metrics', 'dy'],
      key: 'dy',
      render: (value) => formatters['metrics.dy'](value),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Button onClick={() => onRemoveSymbol(record.symbol)} type="link">
          Remove
        </Button>
      ),
    },
  ];

  return <Table columns={columns} dataSource={mergedTickerData} />;
};

export default GeneralMetrics;